export default __webpack_public_path__ + "static/media/duo-ultimate.8163021c.svg";